import Cookie from 'js-cookie';

import { GCLID_COOKIE } from '~/features/cookies/constants';

export function getGclid() {
  return Cookie.get(GCLID_COOKIE);
}
